import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AdminDashboardFilters } from 'views/pages/Dashboard/types';

export const initialAdminDashboardFilters: AdminDashboardFilters = {
  interval: 'this_month',
  to_date: '',
  from_date: '',
  roles: [],
  users: [],
  teams: [],
  supervisor_ids: [],
  record_ids: [],
};

interface IAdminDashboardFiltersStore {
  filters: AdminDashboardFilters;
  setFilters: (filters: Partial<AdminDashboardFilters>) => void;
  resetFilters: () => void;
}

/**
 * Persists the admin dashboard filters across sessions
 */
export const useAdminDashboardFiltersStore =
  create<IAdminDashboardFiltersStore>()(
    persist(
      set => ({
        filters: initialAdminDashboardFilters,
        setFilters: filters =>
          set(state => ({ filters: { ...state.filters, ...filters } })),
        resetFilters: () => set({ filters: initialAdminDashboardFilters }),
      }),
      {
        name: 'admin-dashboard-filters-store',
      },
    ),
  );

export default useAdminDashboardFiltersStore;
